import React from 'react';
import classNames from 'classnames';
import CustomLink from '@/components/common/CustomLink';

type ConstituentSectionWrapperProps = {
  actionLabel?: string;
  children?: React.ReactNode;
  className?: string;
  id: string;
  isEditable?: boolean;
  onActionClick?: () => void;
  title: string;
};

const skipPassingEvent = (fn: () => void) => () => fn();

/**
 * This is a wrapper for donor sections
 * which adds title and custom action
 */
function ConstituentSectionWrapper({
  actionLabel = '',
  children = null,
  className = '',
  id = 'constituent-section-wrapper',
  isEditable = false,
  onActionClick = () => {},
  title,
}: ConstituentSectionWrapperProps) {
  return (
    <div
      className={classNames(
        className,
        'relative rounded-lg border border-grey-300 bg-white py-6 px-4 md:px-6',
      )}
      id={id}
    >
      <div className="mb-4 flex w-full items-baseline md:mb-6">
        <h3 className="type-h3">{title}</h3>
        {Boolean(isEditable && actionLabel && onActionClick) && (
          <CustomLink
            data-testid="donor-section-action-btn"
            onClick={skipPassingEvent(onActionClick)}
            className="ml-auto type-body4"
            component="button"
            type="button"
          >
            {actionLabel}
          </CustomLink>
        )}
      </div>
      {children}
    </div>
  );
}

export default ConstituentSectionWrapper;
